<!-- @component A skeleton component that represents a set of textual paragraphs. -->
<script lang="ts">
  import SkeletonPulse from "./internal/SkeletonPulse.svelte";
</script>

<section class="space-y-10 pr-6 py-12">
  <div class="space-y-8">
    <h1><SkeletonPulse width="60%" height={44} /></h1>
    <p class="space-y-1.5">
      <SkeletonPulse width="93%" />
      <SkeletonPulse width="67%" />
    </p>
  </div>

  <div class="space-y-4">
    <h2><SkeletonPulse width="20%" height={32} /></h2>
    <p class="space-y-1">
      <SkeletonPulse width="92%" />
      <SkeletonPulse width="99%" />
      <SkeletonPulse width="40%" />
    </p>
    <p><SkeletonPulse height={160} light /></p>
    <p class="space-y-1">
      <SkeletonPulse width="84%" />
      <SkeletonPulse width="98%" />
      <SkeletonPulse width="73%" />
    </p>
  </div>
</section>
